const data = {
  "energyLabel": {
    "modalTitle": "Energielabel {{rating}}",
    "productSpecificationLink": "Productinformatieblad",
    "opensInNewTab": "opent in nieuw tabblad",
    "informationAboutEnergyLabel": "Informatie over energielabel"
  }
};

export default data;